module.exports = __webpack_public_path__ + "static/media/section4Img2.801cbec5.webp";